interface PageHeadProps {
  title: string;
  description: string;
  ogUrl: string;
  ogImage?: string;
  ogType?: string;
}

export default function PageHead({
  title,
  description,
  ogUrl,
  ogImage = "https://net-basis.net/Bilder/OG-image-1200x630px.jpg",
  ogType = "website",
}: PageHeadProps) {
  const normalizedUrl = ogUrl.endsWith("/") ? ogUrl.slice(0, -1) : ogUrl;

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={normalizedUrl} />
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content="NetBasis International" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:url" content={normalizedUrl} />
    </>
  );
}